'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = 'M320 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-22.6 68.5C285.3 155.8 271.1 160 256 160s-29.3-4.2-41.3-11.5l-88.9 160c37.4 22.6 81.2 35.5 128 35.5 91.8 0 171.9-49.9 214.8-124 2.2-3.8 7.1-5.1 10.9-2.9s5.1 7.1 2.9 10.9c-45.6 78.9-131 132-228.7 132-49.6 0-96.1-13.7-135.8-37.5L15 507.9c-2.1 3.9-7 5.3-10.9 3.1s-5.3-7-3.1-10.9L104.5 313.8c-32.4-22.3-59.7-51.6-79.4-85.8-2.2-3.8-.9-8.7 2.9-10.9s8.7-.9 10.9 2.9c18.3 31.7 43.5 58.9 73.4 79.8l88.7-159.6 .7-1.3C185.9 124.2 176 103.2 176 80 176 35.8 211.8 0 256 0s80 35.8 80 80c0 23.2-9.9 44.2-25.7 58.8l.7 1.3 63.9 115c-4.3 3.2-8.7 6.3-13.2 9.2L297.4 148.5zM497 507.9L416.2 362.4c4.6-2.8 9.1-5.7 13.5-8.7L511 500.1c2.1 3.9 .8 8.7-3.1 10.9s-8.7 .8-10.9-3.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;